import { Message } from 'element-ui';
import dayjs from 'dayjs';

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    );
  }
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function showMsg(msgType, msg) {
  return Message({
    message: msg,
    type: msgType
  });
}

// 获取浏览器信息
export function getUserAgent() {
  const userAgent = window.navigator.userAgent;
  // FireFox
  if (userAgent.indexOf('Firefox') !== -1) {
    return 'Firefox';
  }
  // Edge
  if (userAgent.indexOf('Edge') !== -1) {
    return 'Edge';
  }
  // IE浏览器
  if (userAgent.indexOf('NET') !== -1 && userAgent.indexOf('rv') !== -1) {
    return 'IE';
  }
  // 360极速模式可以区分360安全浏览器和360极速浏览器
  if (
    userAgent.indexOf('WOW') !== -1 &&
    userAgent.indexOf('NET') < 0 &&
    userAgent.indexOf('Firefox') < 0
  ) {
    if (navigator.javaEnabled()) {
      return '360安全浏览器-极速模式';
    } else {
      return '360极速浏览器-极速模式';
    }
  }
  // 360兼容
  if (
    userAgent.indexOf('WOW') !== -1 &&
    userAgent.indexOf('NET') !== -1 &&
    userAgent.indexOf('MSIE') !== -1 &&
    userAgent.indexOf('rv') < 0
  ) {
    return '360兼容模式';
  }
  // Chrome浏览器
  if (userAgent.indexOf('WOW') < 0 && userAgent.indexOf('Edge') < 0) {
    return 'Chrome';
  }
}

export function getTimeRangeNow(strategyList) {
  const nowTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
  const data = dayjs().format('YYYY-MM-DD');
  let index = 0;
  // strategyList.map((item, index) => {
  //   if (
  //     dayjs(`${data} ${item.startTime}:00`).isBefore(nowTime) &&
  //     dayjs(`${data} ${item.endTime}:00`).isAfter(nowTime)
  //   ) {
  //     i = index;
  //     return;
  //   }
  // });
  for (let i = 0; i < strategyList.length; i += 1) {
    if (
      dayjs(`${data} ${strategyList[i].startTime}:00`).isBefore(nowTime) &&
      dayjs(`${data} ${strategyList[i].endTime}:00`).isAfter(nowTime)
    ) {
      index = i;
      return index;
    } else if (
      i < strategyList.length - 1 &&
      dayjs(`${data} ${strategyList[i].endTime}:00`).isBefore(nowTime) &&
      dayjs(`${data} ${strategyList[i + 1].startTime}:00`).isAfter(nowTime)
    ) {
      index = i + 1;
      return index;
    }
  }
  return index;
}

// 获取指定天数之前/之后的日期
export function getDay(day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

  today.setTime(targetday_milliseconds); //注意，这行是关键代码

  var tYear = today.getFullYear();

  var tMonth = today.getMonth();

  var tDate = today.getDate();

  tMonth = doHandleMonth(tMonth + 1);

  tDate = doHandleMonth(tDate);

  return tYear + '-' + tMonth + '-' + tDate;
}

export function doHandleMonth(month) {
  var m = month;

  if (month.toString().length == 1) {
    m = '0' + month;
  }
  return m;
}

// 根据当前日期获取本周开始结束日期：param:yyyy-mm-dd
export function getWeekDate(param) {
  const date = new Date(param.replace(/-/g, '/'));
  if (date.getDay() === 0) {
    date.setDate(date.getDate() - 6);
    const begin = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    date.setDate(date.getDate() + 6);
    const end = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    return [begin, end];
  } else {
    date.setDate(date.getDate() - date.getDay() + 1);
    const begin = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    date.setDate(date.getDate() + 6);
    const end = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    return [begin.replace(/(\/)/g, '-'), end.replace(/(\/)/g, '-')];
  }
}

// 获取某天所在的月的起始日期和结束日期
export function getMonthDate(time) {
  let currentDay = new Date(time);
  let currentFullYear = currentDay.getFullYear();
  let currentMonth = currentDay.getMonth();
  return [
    formatDate(new Date(currentDay.setDate(1))),
    formatDate(new Date(new Date(currentFullYear, currentMonth + 1, 0)))
  ];
}

export function formatDate(date) {
  if (typeof date === 'string') {
    return new Date(`${date} 00:00:00`);
  } else {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    month = Number(month) >= 10 ? month : `0${month}`;
    day = Number(day) >= 10 ? day : `0${day}`;
    return `${year}-${month}-${day}`;
  }
}

// start:开始日期；end:结束日期；index：6（是否包含周六）；7（是否包含周日）
export function includeWeek(startDate, endDate, index) {
  const start = formatDate(startDate);
  const end = formatDate(endDate);
  const differ = (end - start) / (1000 * 60 * 60 * 24);
  const startWeek = start.getDay() === 0 ? 7 : start.getDay();
  const endWeek = end.getDay() === 0 ? 7 : end.getDay();
  if (startWeek === index || endWeek === index) {
    return true;
  } else if (startWeek === 1 && differ > index - 2) {
    return true;
  } else if (startWeek === 2 && differ > index - 3) {
    return true;
  } else if (startWeek === 3 && differ > index - 4) {
    return true;
  } else if (startWeek === 4 && differ > index - 5) {
    return true;
  } else if (startWeek === 5 && differ > index - 6) {
    return true;
  } else {
    return false;
  }
}
